export default __webpack_public_path__ + "static/media/Tracey_Osborne_AHV_In_Moms_We_Trust.1a3f879d.jpg";